var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -504.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/Hospital",
    transform: "translate(1970.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,18.4375 L26,18.4375 L26,15.53125 L23,15.53125 L23,18.4375 Z M23,23.28125 L26,23.28125 L26,20.375 L23,20.375 L23,23.28125 Z M23,28.125 L26,28.125 L26,25.21875 L23,25.21875 L23,28.125 Z M17.5,9.234375 L17.5,6.328125 L20,6.328125 L20,3.90625 L23,3.90625 L23,6.328125 L25.5,6.328125 L25.5,9.234375 L23,9.234375 L23,11.65625 L20,11.65625 L20,9.234375 L17.5,9.234375 Z M17,18.4375 L20,18.4375 L20,15.53125 L17,15.53125 L17,18.4375 Z M17,23.28125 L20,23.28125 L20,20.375 L17,20.375 L17,23.28125 Z M17,28.125 L20,28.125 L20,25.21875 L17,25.21875 L17,28.125 Z M11,18.4375 L14,18.4375 L14,15.53125 L11,15.53125 L11,18.4375 Z M11,23.28125 L14,23.28125 L14,20.375 L11,20.375 L11,23.28125 Z M11,28.125 L14,28.125 L14,25.21875 L11,25.21875 L11,28.125 Z M5,18.4375 L8,18.4375 L8,15.53125 L5,15.53125 L5,18.4375 Z M5,23.28125 L8,23.28125 L8,20.375 L5,20.375 L5,23.28125 Z M5,28.125 L8,28.125 L8,25.21875 L5,25.21875 L5,28.125 Z M12,1 L12,9.738125 C6.566,9.92896875 2,12.156125 2,14.113 L2,32 L12,32 L18,32 L25.089,32 C27.777,32 29.972,30.012125 29.972,27.5892812 L30,1 L12,1 Z",
    id: 60
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsHospital);
export default __webpack_public_path__ + "static/media/buildings-hospital.4216295e.svg";
export { ForwardRef as ReactComponent };